define(['backbone', 'models/admin/BillingPlan'], function(
  Backbone,
  BillingPlanModel
) {
  return Backbone.Collection.extend({
    model: BillingPlanModel
  });
});
